import React from 'react'
import PropTypes from 'prop-types'
import { Title, Level, Text, Box } from '@deseretbook/react-ui'
import { helpers } from '../../../../helpers'

/**
 * Lesson overview section which displays the title, runtime, and description
 *
 * @returns {function} - React Component
 */
export const LessonOverview = ({ lesson, isDark = false }) => {
  return (
    <Box>
      <Title
        title={lesson && lesson.title}
        size={1}
        {...(isDark && { titleProps: { style: { color: isDark ? 'white' : 'black' } } })}
      />
      <Level>
        <Level.Left>
          <Level.Item>
            <Text {...(isDark && { color: 'light' })}>
              {lesson && helpers.formatDuration(lesson.duration, 'long')}
            </Text>
          </Level.Item>
        </Level.Left>
      </Level>

      <Text {...(isDark && { color: 'light' })}>{lesson && lesson.description}</Text>
    </Box>
  )
}

LessonOverview.propTypes = {
  playlist: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
  }),
  isDark: PropTypes.bool,
  updateActiveTab: PropTypes.func,
  lesson: PropTypes.shape({
    description: PropTypes.string,
    duration: PropTypes.number,
    title: PropTypes.string,
  }),
}
